import { AfterContentInit, AfterViewChecked, AfterViewInit, Component, ElementRef, Input, OnInit } from '@angular/core';
import { DialogService } from '../../dialog/services/dialog.service';
import { MediaItemModel } from '../../models/media-item.model';

import { ImageSliderService } from '../../services/image-slider.service';
import { ImageSliderDialogComponent } from '../image-slider/image-slider-dialog/image-slider-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'markdown-text',
  templateUrl: './markdown-text.component.html',
})
export class MarkdownTextComponent {

  @Input() public text: any;
  @Input() public classes = 'markdown';

  private images: MediaItemModel[] = [];

  /**
   * Constructor
   *
   * @param {ElementRef} elementRef
   * @param {ImageSliderService} imageSliderService
   * @param {DialogService} dialogService
   */
  public constructor(
    private elementRef: ElementRef,
    private imageSliderService: ImageSliderService,
    private dialogService: DialogService,
  ) { }

  /**
   * When markdown is ready, load the images
   *
   * @param event
   */
  public onReady(event) {
    this.loadImages();
    this.loadEmbeddedVideos();
  }

  public loadEmbeddedVideos() {
    console.log('load videos');

    const nodes: HTMLCollection = document.getElementsByClassName('embedded-video');
    const elements = Array.from(nodes) as HTMLElement[];

    elements.forEach((element) => {

      const embeddedVideo =  document.createElement('iframe');
      embeddedVideo.setAttribute('src', element.getAttribute('src'));
      embeddedVideo.setAttribute('frameborder', '0');
      embeddedVideo.setAttribute('allowfullscreen', 'true');

      element.appendChild(embeddedVideo);

    });
  }

  /**
   * Opens the image slider dialog
   *
   * @param event
   *
   * @return void
   */
  public openDialog(event): void {

    const index = this.images.findIndex((image) => {
      return image.source === event.target.src;
    });
    const data = {
      images: this.images,
      currentSlideIndex: index,
      imageSliderService: this.imageSliderService,
    };

    this.dialogService.open(ImageSliderDialogComponent, data, 'image-slider');
  }

  /**
   * load the images that are in the markdown text
   *
   * @return void
   */
  private loadImages(): void {
    const elements = this.elementRef.nativeElement.querySelectorAll('img');
    // The images are converted to a MediaItemModel to be used in the dialog slider
    this.images = Array.from(elements).map((el: HTMLImageElement) => {
      return new MediaItemModel(
        el.title,
        null,
        'image',
        null,
        null,
        el.src,
      );
    });

    for (const element of elements) {
      element.addEventListener('click', this.openDialog.bind(this));
    }
  }
}
